import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/AdminSettingBooth';

const GetSettingBoothReducer = handleActions({
    [Actions.getSettingBoothRequested]: (state) => ({
        ...state,
        isFetching: true,
        isCompleted: false,
    }),
    [Actions.getSettingBoothReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        isCompleted: true,
        data: action.payload,
    }),
    [Actions.getSettingBoothReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        isCompleted: true,
        errors: action.payload.errors,
    }),
    [Actions.getSettingBoothClear]: () => ({
        isCompleted: false,
        isSuccessful: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    isCompleted: false,
    data: {},
    errors: {},
});

const UpdateSettingBoothReducer = handleActions({
    [Actions.updateSettingBoothRequested]: (state) => ({
        ...state,
        isFetching: true,
        isCompleted: false,
        isSuccessful: undefined,
    }),
    [Actions.updateSettingBoothReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        isCompleted: true,
        isSuccessful: true,
        data: action.payload,
    }),
    [Actions.updateSettingBoothReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        isCompleted: true,
        isSuccessful: false,
        errors: action.payload.errors,
    }),
    [Actions.updateSettingBoothClear]: () => ({
        isFetching: false,
        isCompleted: false,
        isSuccessful: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    isCompleted: false,
    isSuccessful: undefined,
    data: {},
    errors: {},
});

export default combineReducers({
    get: GetSettingBoothReducer,
    update: UpdateSettingBoothReducer,
});
